package uz.ferro.erp.feature.order.model

import kotlinx.serialization.Serializable

@Serializable
data class OrderPaymentInfo(
    val paymeLink: String
)